export default "__VITE_ASSET__zlIMgS9o__"